import { Button, Modal } from '@hub/shared'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import './modal-filter.component.scoped.scss'
import './modal-filter.component.scss'
import { SqModal } from '@squidit/react-css'

interface Props extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  open?: boolean
  header?: any
  footer?: any
  closeModal?: (open: boolean) => any
  openModal?: (open: boolean) => any
}

export default ({ children, footer, header = '', className = '', closeModal, openModal, open }: Props) => {
  const [t] = useTranslation('filterComponent')

  footer = (
    <div className="footer-buttons">
      <Button borderColor="var(--transparent)" textColor="var(--gray)" color="var(--transparent)" onClick={() => closeModal(false)}>
        {t('cancel')}
      </Button>
      <Button borderStyle={'none'} onClick={() => closeModal(true)}>
        {t('filter')}
      </Button>
    </div>
  )

  return (
    <div className={className} style={{ flexShrink: 0 }}>
      <Button
        className="py-0 display-flex"
        size="sm"
        rounded
        color="var(--background_secondary)"
        borderColor="var(--gray_light)"
        onClick={() => openModal(true)}
      >
        <span className="display-flex align-items-center" style={{ color: 'var(--text_color)', gap: '0.2rem' }}>
          <i className="p-1 fa-regular fa-bars-filter" style={{ color: 'var(--gray)' }}></i>
          {t('buttonText')}
        </span>
      </Button>

      <SqModal
        open={open}
        onCloseChange={() => closeModal(false)}
        forceMobileNoMargin
        modalClass="modal-class-campaign-filter"
        className="modal-campaign-filter"
        header={
          <h5 key="campaign-filter-title" className="mb-0">
            {header}
          </h5>
        }
        footer={footer}
      >
        {children}
      </SqModal>
    </div>
  )
}
